"use client";

import { motion, useScroll, useTransform,useSpring  } from "framer-motion";
import { useRef } from "react";
import * as All from '@/element/common/elmntbase';

export default function ZoomOutOnScroll({children}:any) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["-700px start", "end end"], // Equivalent to GSAP start position
  });

   // Smooth scrolling effect using useSpring
   const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100, // Controls how "stiff" the animation is
    damping: 30, // Controls smoothness (higher = smoother)
    mass: 1,
  });

  // Transform properties
  const scale = useTransform(smoothProgress, [0, 1], [1, 1.15]); // Scaling effect
  const x = useTransform(smoothProgress, [0, 1], [-50, 0]); // Horizontal move (optional)
  const y = useTransform(smoothProgress, [0, 1], [-50, 0]); // Vertical move (optional)

  return (
    <div className="scroll-img" ref={ref}>
      <All.MotionDiv    
        className="video-card-img-wrapper"         
        style={{ scale }}
        transition={{ duration: 15, ease: "linear" }}
      >
        {children}
        </All.MotionDiv>
    </div>
  );
}
